// assets/givonate-cartdrawer.js
(function () {
  // ====== Réglages debug ======
  const DEBUG = true;
  const log = (...a) => { if (DEBUG) console.log('[GivonateDBG]', ...a); };
  const warn = (...a) => console.warn('[GivonateDBG]', ...a);

  // ====== Sélecteurs du widget Givonate ======
  const WIDGET_SELECTOR = '.Givonate-Widget';
  const BUTTON_SELECTOR = '.GivonateButton';

  // Sections "par défaut" — la détection auto ajoutera celles manquantes
  const DEFAULT_SECTIONS = [
    'cart-drawer',
    'cart-drawer-items',
    'cart-items',
    'main-cart-items',
    'cart-drawer-footer',
    'cart-footer',
    'cart-icon-bubble',
    'cart-live-region-text'
  ];

  // ====== Utils ======
  const sleep = (ms) => new Promise(r => setTimeout(r, ms));

  async function getCartState() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return null;
      const json = await res.json();
      if (DEBUG) {
        const donation = (json.items||[]).find(i =>
          (i.product_type||'').toLowerCase().includes('don') ||
          (i.title||'').toLowerCase().includes('don') ||
          (i.properties && Object.keys(i.properties).length)
        );
        log('cart.js -> item_count:', json.item_count, 'total_price:', json.total_price, 'donation item?', !!donation);
      }
      return json;
    } catch (e) { warn('getCartState failed', e); return null; }
  }

  function snapshotCart(cart) {
    if (!cart) return null;
    return {
      item_count: cart.item_count,
      total_price: cart.total_price,
      updated_at: cart.updated_at,
      lines: (cart.items || []).map(i => ({
        id: i.id, qty: i.quantity, key: i.key,
        props: i.properties ? JSON.stringify(i.properties) : ''
      }))
    };
  }

  function cartsDiffer(a, b) {
    if (!a || !b) return false;
    if (a.item_count !== b.item_count) return true;
    if (a.total_price !== b.total_price) return true;
    if (a.updated_at && b.updated_at && a.updated_at !== b.updated_at) return true;
    if (a.lines.length !== b.lines.length) return true;
    for (let i = 0; i < a.lines.length; i++) {
      const x = a.lines[i], y = b.lines[i];
      if (x.id !== y.id || x.qty !== y.qty || x.key !== y.key || x.props !== y.props) return true;
    }
    return false;
  }

  // ====== Détection automatique des sections "cart*" présentes dans le DOM ======
  function detectCartSectionIds() {
    const ids = new Set(DEFAULT_SECTIONS);
    document.querySelectorAll('[id^="shopify-section-"]').forEach(el => {
      const id = el.id.replace('shopify-section-','');
      if (/^cart/.test(id)) ids.add(id);
    });
    document.querySelectorAll('[data-section-id]').forEach(el => {
      const id = el.getAttribute('data-section-id');
      if (id && /^cart/.test(id)) ids.add(id);
    });
    const arr = Array.from(ids);
    log('Sections détectées:', arr);
    return arr;
  }

  // ====== Rafraîchissement HTML par section (fallback fiable) ======
  async function refreshSections(sectionIds = 'auto') {
    const updateHTML = (id, html) => {
      if (!html) return false;
      // Conteneur standard
      const byId = document.getElementById(`shopify-section-${id}`);
      if (byId) {
        byId.innerHTML = html;
        byId.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
        return true;
      }
      // Variante imbriquée
      const byData = document.querySelector(`[data-section-id="${id}"]`);
      if (byData) {
        byData.innerHTML = html;
        byData.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
        return true;
      }
      return false;
    };

    const targets = sectionIds === 'auto' ? detectCartSectionIds() : sectionIds;
    for (const id of targets) {
      try {
        const url = `/?section_id=${encodeURIComponent(id)}&sections_url=${encodeURIComponent(location.pathname)}`;
        const r = await fetch(url, { credentials: 'same-origin' });
        const html = await r.text();
        const replaced = updateHTML(id, html);

        // Si on rafraîchit la section "cart-drawer", on remplace aussi le composant au besoin
        if (id === 'cart-drawer') {
          const temp = document.createElement('div');
          temp.innerHTML = html;
          const incoming = temp.querySelector('cart-drawer, #CartDrawer, [data-cart-drawer]');
          const existing =
            document.querySelector('cart-drawer') ||
            document.getElementById('CartDrawer') ||
            document.querySelector('[data-cart-drawer]');
          if (incoming && existing) {
            existing.replaceWith(incoming);
            log('cart-drawer component replaced');
          }
        }

        log(`Section "${id}" rafraîchie (${replaced ? 'OK' : 'non trouvée dans DOM'})`);
      } catch (e) {
        warn('refresh section failed', id, e);
      }
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  // ====== Ouverture du drawer (robuste) ======
  async function openCartDrawer({ retries = 10, delay = 60 } = {}) {
    for (let i = 0; i < retries; i++) {
      const drawerEl =
        document.querySelector('cart-drawer') ||
        document.getElementById('CartDrawer') ||
        document.querySelector('[data-cart-drawer]');
      if (drawerEl) {
        try {
          if (typeof drawerEl.open === 'function') { drawerEl.open(); log('drawer.open()'); return true; }
          drawerEl.setAttribute('open', '');
          drawerEl.classList.add('active', 'is-open', 'open');
          const toggleBtn =
            document.querySelector('[data-cart-drawer-toggle]') ||
            document.querySelector('[data-drawer-toggle="CartDrawer"]') ||
            document.querySelector('[data-action="open-cart"]') ||
            document.querySelector('[aria-controls="CartDrawer"]');
          if (toggleBtn) { toggleBtn.click(); log('drawer toggle clicked'); return true; }
          document.body.dispatchEvent(new CustomEvent('cart:open'));
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
          log('drawer open events dispatched');
          return true;
        } catch {}
      }
      await sleep(delay);
    }
    warn('drawer not found to open');
    return false;
  }

  // ====== Bloque redirection /cart ======
  let donationInProgress = false;
  let originalAssign, originalReplace, originalPushState;

  function enableNoRedirectMode() {
    if (donationInProgress) return;
    donationInProgress = true;
    originalAssign = window.location.assign.bind(window.location);
    originalReplace = window.location.replace.bind(window.location);
    originalPushState = history.pushState.bind(history);
    const blockIfCartURL = (url) => {
      try { return new URL(url, location.origin).pathname === '/cart'; }
      catch { return (typeof url === 'string') && url.replace(location.origin, '').startsWith('/cart'); }
    };
    window.location.assign = (url) => { if (blockIfCartURL(url)) { log('blocked assign->/cart'); return; } return originalAssign(url); };
    window.location.replace = (url) => { if (blockIfCartURL(url)) { log('blocked replace->/cart'); return; } return originalReplace(url); };
    history.pushState = (state, title, url) => { if (url && blockIfCartURL(url)) { log('blocked pushState->/cart'); return; } return originalPushState(state, title, url); };
  }
  function disableNoRedirectMode() {
    if (!donationInProgress) return;
    window.location.assign = originalAssign;
    window.location.replace = originalReplace;
    history.pushState = originalPushState;
    donationInProgress = false;
  }

  // ====== Wiring ======
  function wireButtons(scope = document) {
    scope.querySelectorAll(`${WIDGET_SELECTOR} ${BUTTON_SELECTOR}`).forEach((btn) => {
      if (btn.__givonateWired) return;
      btn.__givonateWired = true;

      btn.addEventListener('click', async () => {
        try {
          // 1) Snapshot AVANT + blocage redirection
          const prevCart = await getCartState();
          const prevSnap = snapshotCart(prevCart);
          enableNoRedirectMode();

          // 2) Attendre un vrai changement (prix OU contenu), max ~5s
          const start = Date.now();
          let changed = false;
          while (Date.now() - start < 5000) {
            await sleep(100);
            const curr = await getCartState();
            const currSnap = snapshotCart(curr);
            if (prevSnap && currSnap && cartsDiffer(prevSnap, currSnap)) {
              changed = true;
              break;
            }
          }
          disableNoRedirectMode();
          log('panier changé ?', changed);

          // 3) Rafraîchir toutes les sections "cart*" détectées automatiquement
          await refreshSections('auto');

          // 4) Attendre ~0,2s pour laisser le DOM se poser puis ouvrir le drawer
          await sleep(0);
          await openCartDrawer();

        } catch (e) {
          warn('handler error (safe):', e);
          try {
            disableNoRedirectMode();
            await refreshSections('auto');
            await sleep(0);
            await openCartDrawer();
          } catch {}
        }
      }, { capture: true });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    wireButtons(document);
  });

  // Si le widget est injecté après coup
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (!m.addedNodes?.length) continue;
      m.addedNodes.forEach((n) => {
        if (!(n instanceof HTMLElement)) return;
        if (n.matches && n.matches(WIDGET_SELECTOR)) wireButtons(n);
        else if (n.querySelector) wireButtons(n);
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
